import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type PersonaQuestionIdsQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.UserSurveysFilter>;
}>;


export type PersonaQuestionIdsQuery = { userSurveys?: { edges?: Array<{ node: { questionConfig: { surveyQuestions: Array<{ questionId?: string | null }> } } }> | null } | null };


export const PersonaQuestionIdsDocument = /*#__PURE__*/ gql`
    query personaQuestionIds($filters: UserSurveysFilter) {
  userSurveys(filters: $filters) {
    edges {
      node {
        questionConfig {
          surveyQuestions {
            questionId
          }
        }
      }
    }
  }
}
    `;

export function usePersonaQuestionIdsQuery(options?: Omit<Urql.UseQueryArgs<PersonaQuestionIdsQueryVariables>, 'query'>) {
  return Urql.useQuery<PersonaQuestionIdsQuery, PersonaQuestionIdsQueryVariables>({ query: PersonaQuestionIdsDocument, ...options });
};